import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";
import { getSessionId } from "./authService";

async function withSession(body = {}) {
  const sessionID = await getSessionId();
  if (!sessionID) {
    throw new Error("customer_chat_agent_no_session");
  }
  return { ...body, sessionID: String(sessionID).trim() };
}

async function post(path, body, opts = {}) {
  const payload = await withSession(body);
  if (process.env.NODE_ENV === "development") {
    console.log("[AI_CHAT_DEBUG_FE]", {
      action: "post_request",
      path,
      body,
      payloadPreview: { ...payload, sessionID: payload?.sessionID ? "***" : null },
    });
  }
  const { data } = await axios.post(resolveApiUrl(path), payload, {
    withCredentials: true,
    timeout: opts.timeout ?? 120000,
    headers: { "Content-Type": "application/json" },
  });
  if (data && data.status === "fail") {
    if (process.env.NODE_ENV === "development") {
      console.log("[AI_CHAT_DEBUG_FE]", {
        action: "post_fail_payload",
        path,
        response: data,
      });
    }
    const err = new Error(
      typeof data.message === "string" && data.message.trim()
        ? data.message.trim()
        : "customer_chat_agent_request_failed"
    );
    err.customerChatAgentPayload = data;
    throw err;
  }
  return data;
}

export async function listCustomerChatSessions(params = {}) {
  return post("/api/agent/customer-chat/sessions/list", {
    limit: params.limit ?? 100,
  });
}

export async function getCustomerChatSessionDetail(chatSessionId, messagesLimit = 300) {
  return post("/api/agent/customer-chat/session/detail", {
    chat_session_id: chatSessionId,
    messages_limit: messagesLimit,
  });
}

export async function markCustomerChatSessionRead(chatSessionId, unread = false) {
  return post("/api/agent/customer-chat/session/mark-read", {
    chat_session_id: chatSessionId,
    unread,
  });
}

export async function assignCustomerChatSessionLead(chatSessionId, agentId) {
  return post("/api/agent/customer-chat/session/assign", {
    chat_session_id: chatSessionId,
    agent_id: agentId,
  });
}

/**
 * @param {{ agentId?: string|number }} [opts]
 * Admin: optional agent_id in body targets that agent’s ref; otherwise server default (env).
 */
export async function getCustomerChatPublicLink(opts = {}) {
  const body = {};
  if (opts.agentId != null && String(opts.agentId).trim() !== "") {
    body.agent_id = String(opts.agentId).trim();
  }
  if (process.env.NODE_ENV === "development") {
    console.log("[AI_CHAT_DEBUG_FE]", {
      action: "public_link_request_prepare",
      inputAgentId: opts.agentId ?? null,
      finalBody: body,
    });
  }
  return post("/api/agent/customer-chat/public-link", body);
}
